<template>
  <div class="app-container" style="width:800px;">
    <el-form :model="data" :rules="rules" ref="form" label-width="75px">
      基本信息
      <el-row class="row-border">
        <el-col :span="12">
          <el-form-item label="名称">
            <el-input v-model="data.name" placeholder="请输入名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话">
            <el-input v-model="data.phone" placeholder="请输入电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      其他信息
      <el-row class="row-border">
        <el-col :span="12">
          <el-form-item label="账号">
            <el-input v-model="data.account" placeholder="请输入账号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱">
            <el-input v-model="data.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="下载地址">
            <el-col :span="24">
              <el-input v-model="data.url" placeholder="请输入下载地址" />
              <el-upload 
                ref="upload"
                style="position: absolute;top: 0;right: 0;"
                :action="host + '/api/Common/UploadFile'"
                :on-success="onSuccess"
                accept=".pdf,.txt,.docx,.xlsx," 
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeFileUpload">
                  <el-button icon="el-icon-upload2" type="primary" title="点击选择文件"></el-button>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="display: inline-block;margin: 3px 0 10px;">子表名称</div>
          <el-button style="float: right;" type="primary" icon="el-icon-plus" @click="add">添加</el-button>
            <el-table :data="tableData" border style="width: 100%;">
              <el-table-column prop="name" label="姓名" align="center">
                <template slot-scope="{row}">
                  <el-input style="width: 100%;" v-model="row.name" @blur="change(row)" placeholder="请输入姓名"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" align="center" min-width="100px">
                <template slot-scope="{row}">
                  <el-input style="width: 100%;" v-model="row.remark" @blur="change(row)" placeholder="请输入备注"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="60px">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="del(row,$index)" icon="el-icon-delete"></el-button>
                </template>
              </el-table-column>
            </el-table>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "demo",
  components: {

  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        name: "",
        phone: "",
        account: "",
        email: "",
        url: "",
        arr: []
      },
      headers: { Authorization: "" },
      tableData: [],
      delList: [],
      rules: {},
    };
  },

  methods: {
    toUpload() {

    },
    beforeFileUpload(file) {
      var limit = this.$store.state.user.attSize;
      this.headers.Authorization = "Bearer " + this.$commonJs.getCookie("token");
      const result = file.size/1024/1024 <= limit || limit == 0;
      if(!result) {
        this.$message.error("附件大小不能超过" + limit + "M");
      }
      return result;
    },
    onSuccess(res,file) {
      if(res.Code==0) {
        this.data.url = res.Data;
        this.$message.success(res.Msg);
      } else {
        this.$message.error(res.Msg);
      }
    },
    //---------------------------------
    onEditOpened(data) {
				data.arr.forEach(e => {
					delete e.T;
					this.tableData.push(e);
				})
			},
			add() {
				this.tableData.push({
					T: 0,
					parentId: this.data.RecordId,
					RecordId: 0,
					name: "",
					remark: ""
				})
			},
			change(row) {
				if(!(row.T === 0)) {
					row.T = 1;
				}
			},
			del(row,index) {
				if(!(row.T === 0)) {
					row.T = 2;
					this.delList.push(row);
				}
				this.tableData.splice(index,1);
			},
			onBeforeSave() {
				var td = this.tableData;
				var to = [];
				for(var i = 0; i < td.length; i++) {
					if(!td[i].name) {
						this.$message.error("请输入姓名");
						return false;
					}
					if(td[i].T === 0 || td[i].T === 1) {
						to.push(td[i]);
					}
				}
				this.data.arr = to.concat(this.delList);
			},
			onClosed() {
				this.tableData = [];
				this.delList = [];
			}
  },
};
</script>
 